import React from 'react';

import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './WelcomeStep.module.scss';
import { TitledImage } from './TitledImage/TitledImage';
import { SubmitButton } from '../../components/SubmitButton/SubmitButton';
import { PhoneNumberInput } from '../../../../../shared/components/form-components';

type WelcomeStepProps = {
  onSubmit: (formValues: FormValues) => void;
};

type FormValues = {
  phoneNumber: string;
};

const WelcomeStep = ({ onSubmit }: WelcomeStepProps) => {
  const { control, handleSubmit } = useForm<FormValues>();

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h1 className={classes.title}>Welcome to ScanIQ!</h1>
      <Paper variant="boxWithPadding">
        <TitleWithDescription
          title="Why choose the InBody scanner?"
          description="The InBody is the most advanced body composition analyzer on the market and is
          trusted by leading hospitals, universities, and professional sports teams
          because of its precision."
          descriptionColor="main-black"
        />
        <TitledImage />
        <TitleWithDescription
          title="Your First Step"
          description='Please enter your phone number (this will also be your "InBody ID").'
          descriptionColor="main-black"
        />
        <PhoneNumberInput
          control={control}
          className={classes.cellPhoneInput}
          variant="outlined"
          label="Cell Phone"
          name="phoneNumber"
          rules={{
            required: 'Cell Phone is required',
          }}
        />
      </Paper>
      <SubmitButton hideBackToFirstPage />
    </form>
  );
};

export { WelcomeStep };
